const stMob = {
  containPixPageMb: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
  },
  containHeader: {
    display: 'flex',
    height: 'auto',
    width: '100%',
    padding: '5px 10px',
  },
  titleHeader: {
    fontWeight: 'bold',
  },
  labelPage: {
    textAlign: 'center',
    height: 'auto',
    width: '100%',
    fontSize: '15px',
  },
  buttonOutlined: {
    width: '100%',
    height: 'auto',
    padding: '10px',
    margin: '10px 0',
    border: 'none',
    fontSize: '18px',
  },
  containOverlayModal: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1,
  },
  containModal: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '90%',
    backgroundColor: '#f5f5f5',
    padding: '10px',
    borderRadius: '5px',
  },
  containTitleModal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '5px 10px 0px 10px',
  },
}

export { stMob }
